export const MENU_CATEGORY_OPTIONS = [
  { id: '', label: 'すべてのカテゴリ' },
  { id: 'headspa', label: 'ヘッドスパ' },
  { id: 'cut', label: 'カット' },
  { id: 'color', label: 'カラー' },
  { id: 'treatment', label: 'トリートメント' },
];

export const CATEGORY_OPTIONS = [
  { id: '', value: '', label: '選択してください' },
  { id: 'headspa', value: 'headspa', label: 'ヘッドスパ' },
  { id: 'cut', value: 'cut', label: 'カット' },
  { id: 'color', value: 'color', label: 'カラー' },
  { id: 'treatment', value: 'treatment', label: 'トリートメント' },
];

export const DURATION_OPTIONS = [
  { value: '', label: '選択してください' },
  { value: '30', label: '30分' },
  { value: '45', label: '45分' },
  { value: '60', label: '60分' },
  { value: '90', label: '90分' },
  { value: '120', label: '120分' },
];

export const AVOID_CONDITIONS = [
  { id: '1', label: '妊娠中' },
  { id: '2', label: '皮膚炎' },
  { id: '3', label: 'アレルギー' },
  { id: '4', label: '高血圧' },
];

export const TARGET_AUDIENCE = [
  { value: 1, label: '女性' },
  { value: 2, label: '男性' },
  { value: 3, label: 'キッズ' },
];

export const MANAGEMENT_TAGS = ['新規顧客限定', '平日限定', '期間限定'];
